import React from 'react';
import { IconStarCircleFilled } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './PartnerMiniModule.styles';

export const BRAND_RATING_TEST_ID = 'PartnerMiniModule-brand-rating-test-id';

interface PartnerMiniModuleProps {
  linkHref: string;
  location: string;
  logoSrc: string;
  name: string;
  onLinkClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  partnerRating?: number;
  partnerReviewCount?: number;
}

export const PartnerMiniModule = ({
  linkHref,
  location,
  logoSrc,
  name,
  onLinkClick,
  partnerRating,
  partnerReviewCount,
}: PartnerMiniModuleProps) => {
  const brandReviewsText = partnerReviewCount
    ? `(${partnerReviewCount.toLocaleString()} Brand reviews)`
    : '';

  return (
    <div css={styles.root}>
      <img alt="" src={logoSrc} />
      <ul>
        <li>
          Sold by{' '}
          <strong>
            <a href={linkHref} onClick={onLinkClick}>
              {name}
            </a>
          </strong>
        </li>
        <li>
          From <strong>{location}</strong>
        </li>
        {partnerRating && (
          <li data-testid={BRAND_RATING_TEST_ID}>
            <IconStarCircleFilled color="var(--brand-purple-base)" height={16} width={16} />
            <strong>{partnerRating}/5</strong> {brandReviewsText}
          </li>
        )}
      </ul>
    </div>
  );
};
